var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8675 0.753471L10.3184 5.27336L14.8675 9.79326C14.9498 9.62137 14.9997 9.43135 14.9997 9.22844V1.31829C14.9997 1.11535 14.9498 0.925356 14.8675 0.753471Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.682 0H1.31872C1.11578 0 0.925791 0.0498926 0.753906 0.132129L6.56825 5.91718C7.08235 6.43128 7.91837 6.43128 8.43247 5.91718L14.2468 0.132129C14.0749 0.0498926 13.8849 0 13.682 0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.132129 0.753471C0.0498926 0.925356 0 1.11535 0 1.31829V9.22844C0 9.43138 0.0498926 9.6214 0.132129 9.79326L4.68132 5.27336L0.132129 0.753471Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69763 5.89482L9.05389 6.53857C8.19728 7.39518 6.80342 7.39518 5.94681 6.53857L5.3031 5.89482L0.753906 10.4147C0.925791 10.497 1.11578 10.5468 1.31872 10.5468H13.682C13.8849 10.5468 14.0749 10.497 14.2468 10.4147L9.69763 5.89482Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhite);
export default __webpack_public_path__ + "static/media/email-white.a8a97960621b75e1423d15d09857bc36.svg";
export { ForwardRef as ReactComponent };